import React from 'react';

const ConcalLogo = ({ size = 'default', className = '', showTagline = true }) => {
  const sizeClasses = {
    small: 'h-8',
    default: 'h-10',
    large: 'h-12',
    xl: 'h-16'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/assets/images/CONCAL_wht_(1).png"
        alt="CONCAL - Contract Analyzer"
        className={`${sizeClasses[size]} w-auto object-contain`}
        loading="lazy"
      />
    </div>
  );
};

export default ConcalLogo;
